/**
 * URL-veiligheid voor DOM-sinks. Backend-responses en geplakte invoer belanden
 * op enkele plekken direct in een <img src> of window.open(); deze helpers
 * weren javascript:/data:text-injectie (DOM-XSS) en open-redirects.
 */

/**
 * Whitelist voor een <img src>: alleen http(s) en `data:image/…` (de dev-preview
 * leest een geüploade foto als data:image-URL). Al het andere — javascript:,
 * vbscript:, data:text/html — geeft een lege string terug, zodat de <img> niets
 * laadt in plaats van een injectie uit te voeren. UI-gedrag voor echte
 * afbeeldings-URL's blijft ongewijzigd.
 */
export function safeImageSrc(url: string | undefined | null): string {
  if (!url) return '';
  const trimmed = url.trim();
  let parsed: URL;
  try {
    parsed = new URL(trimmed);
  } catch {
    return '';
  }
  if (parsed.protocol === 'http:' || parsed.protocol === 'https:') return parsed.href;
  if (parsed.protocol === 'data:' && /^data:image\//i.test(trimmed)) return trimmed;
  return '';
}

/**
 * Opent een externe URL in een nieuw tabblad, maar alleen als hij parseert en
 * https (of same-origin) is. Zo kan een gemanipuleerde backend-respons geen
 * javascript:/data:-navigatie forceren (open redirect). Retourneert false als de
 * URL geweigerd is.
 */
export function openExternalUrl(url: string): boolean {
  let parsed: URL;
  try {
    parsed = new URL(url, window.location.origin);
  } catch {
    return false;
  }
  if (parsed.protocol !== 'https:' && parsed.origin !== window.location.origin) {
    return false;
  }
  window.open(parsed.href, '_blank', 'noopener,noreferrer');
  return true;
}

/**
 * Whitelist voor een <a href> naar een backend-geleverde download-URL (signed
 * GCS-links): alleen https parseert door, al het andere geeft een lege string
 * zodat de link niet rendert in plaats van javascript:-injectie uit te voeren.
 */
export function safeHttpsHref(url: string | undefined | null): string {
  if (!url) return '';
  try {
    const parsed = new URL(url.trim());
    return parsed.protocol === 'https:' ? parsed.href : '';
  } catch {
    return '';
  }
}
